import LTR from "@brand-icons/global/bag/bag-ltr.svg";

import { iconFactory } from "../iconFactory";

export const BagIcon = iconFactory("BagIcon", LTR);
